import { useMutation } from '@apollo/client'
import { RemoveUserTagsDocument } from '../../../../../graphql/generated'
import useAlerts from '../../../hooks/useAlerts'

export default function useRemoveUserTags() {
  const { createAlert } = useAlerts()
  const [mutation, results] = useMutation(RemoveUserTagsDocument, {
    onError: () => {
      createAlert('There was a problem removing user tags')
    }
  })

  return { mutation, results }
}
